import { useQuery } from "@tanstack/react-query";

import { fetchValidatorsScores } from "services/marinade/fetchValidatorsScores";

export const useValidatorScores = () => {
  const { data: scores } = useQuery(
    ["useValidatorsScores"],
    () => fetchValidatorsScores(),
    {
      staleTime: 4 * 60 * 60 * 1000,
      refetchInterval: 4 * 60 * 60 * 1000,
    }
  );
  let mndeGovernedStake = 0;
  let mSOLGovernedStake = 0;
  const dsValidators: string[] = [];

  scores?.forEach((score) => {
    mndeGovernedStake += score.target_stake_vemnde;
    mSOLGovernedStake += score.target_stake_msol;
    if (
      !dsValidators.includes(score.vote_account) &&
      (score.target_stake_algo > 0 ||
        score.target_stake_vemnde > 0 ||
        score.target_stake_msol > 0)
    ) {
      dsValidators.push(score.vote_account);
    }
  });
  return {
    scores,
    mndeGovernedStake,
    mSOLGovernedStake,
    numberOfDsConsideredValidators: dsValidators.length,
  };
};
